export default "__VITE_ASSET__9im$RJZz__"